import { useTheme } from "@mui/material/styles";

const CalendarIcon = (): JSX.Element => {
  const theme = useTheme();

  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.66675 9.99967C1.66675 6.85698 1.66675 5.28563 2.64306 4.30932C3.61937 3.33301 5.19072 3.33301 8.33342 3.33301H11.6667C14.8094 3.33301 16.3808 3.33301 17.3571 4.30932C18.3334 5.28563 18.3334 6.85698 18.3334 9.99967V11.6663C18.3334 14.809 18.3334 16.3804 17.3571 17.3567C16.3808 18.333 14.8094 18.333 11.6667 18.333H8.33341C5.19072 18.333 3.61937 18.333 2.64306 17.3567C1.66675 16.3804 1.66675 14.809 1.66675 11.6663V9.99967Z"
          stroke={theme.palette.otherTextTertiary.main}
          strokeWidth="1.5"
        />
        <path
          d="M5.83325 3.33301V2.08301"
          stroke={theme.palette.otherTextTertiary.main}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M14.1667 3.33301V2.08301"
          stroke={theme.palette.otherTextTertiary.main}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M2.08325 7.5H17.9166"
          stroke={theme.palette.otherTextTertiary.main}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M14.9999 14.1667C14.9999 14.6269 14.6268 15 14.1666 15C13.7063 15 13.3333 14.6269 13.3333 14.1667C13.3333 13.7064 13.7063 13.3333 14.1666 13.3333C14.6268 13.3333 14.9999 13.7064 14.9999 14.1667Z"
          fill={theme.palette.otherTextTertiary.main}
        />
        <path
          d="M14.9999 10.8333C14.9999 11.2936 14.6268 11.6667 14.1666 11.6667C13.7063 11.6667 13.3333 11.2936 13.3333 10.8333C13.3333 10.3731 13.7063 10 14.1666 10C14.6268 10 14.9999 10.3731 14.9999 10.8333Z"
          fill={theme.palette.otherTextTertiary.main}
        />
        <path
          d="M10.8334 14.1667C10.8334 14.6269 10.4603 15 10.0001 15C9.53984 15 9.16675 14.6269 9.16675 14.1667C9.16675 13.7064 9.53984 13.3333 10.0001 13.3333C10.4603 13.3333 10.8334 13.7064 10.8334 14.1667Z"
          fill={theme.palette.otherTextTertiary.main}
        />
        <path
          d="M10.8334 10.8333C10.8334 11.2936 10.4603 11.6667 10.0001 11.6667C9.53984 11.6667 9.16675 11.2936 9.16675 10.8333C9.16675 10.3731 9.53984 10 10.0001 10C10.4603 10 10.8334 10.3731 10.8334 10.8333Z"
          fill={theme.palette.otherTextTertiary.main}
        />
        <path
          d="M6.66667 14.1667C6.66667 14.6269 6.29357 15 5.83333 15C5.3731 15 5 14.6269 5 14.1667C5 13.7064 5.3731 13.3333 5.83333 13.3333C6.29357 13.3333 6.66667 13.7064 6.66667 14.1667Z"
          fill={theme.palette.otherTextTertiary.main}
        />
        <path
          d="M6.66667 10.8333C6.66667 11.2936 6.29357 11.6667 5.83333 11.6667C5.3731 11.6667 5 11.2936 5 10.8333C5 10.3731 5.3731 10 5.83333 10C6.29357 10 6.66667 10.3731 6.66667 10.8333Z"
          fill={theme.palette.otherTextTertiary.main}
        />
      </svg>
    </div>
  );
};

export default CalendarIcon;
